import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7f80341e"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "   ", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "   ", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Iconfont = _resolveComponent("Iconfont");
  const _component_sub_item = _resolveComponent("sub-item", true);
  const _component_el_sub_menu = _resolveComponent("el-sub-menu");
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  return _openBlock(), _createElementBlock("div", null, [_ctx.data.children && _ctx.data.children.length > 0 && !_ctx.data.meta.alwaysShow ? (_openBlock(), _createBlock(_component_el_sub_menu, {
    key: 0,
    index: _ctx.data.name,
    onOpen: _ctx.handleOpen,
    onClose: _ctx.handleClose
  }, {
    title: _withCtx(() => [_ctx.data.meta.icon ? (_openBlock(), _createBlock(_component_Iconfont, {
      key: 0,
      name: _ctx.data.icon || _ctx.data.meta.icon,
      class: "padding_r-5"
    }, null, 8, ["name"])) : _createCommentVNode("", true), _hoisted_1, _createElementVNode("span", null, _toDisplayString(_ctx.data.meta.title), 1)]),
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.children, item => {
      return _openBlock(), _createBlock(_component_sub_item, {
        key: `${item.name}`,
        index: _ctx.data.name,
        data: item,
        path: `${_ctx.path}/${item.path}`,
        onSubmenuOpen: _cache[0] || (_cache[0] = $event => _ctx.$emit('submenu-open')),
        onSubmenuClose: _cache[1] || (_cache[1] = $event => _ctx.$emit('submenu-close'))
      }, null, 8, ["index", "data", "path"]);
    }), 128))]),
    _: 1
  }, 8, ["index", "onOpen", "onClose"])) : _withDirectives((_openBlock(), _createBlock(_component_el_menu_item, {
    key: 1,
    index: _ctx.data.name,
    onClick: _ctx.clickHandle
  }, {
    title: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.data.meta.title), 1)]),
    default: _withCtx(() => [_ctx.data.meta.icon ? (_openBlock(), _createBlock(_component_Iconfont, {
      key: 0,
      name: _ctx.data.meta.icon,
      class: "padding_r-5"
    }, null, 8, ["name"])) : _createCommentVNode("", true), _hoisted_2]),
    _: 1
  }, 8, ["index", "onClick"])), [[_vShow, !_ctx.data.meta.hidden]])]);
}